import { render } from "./ReceivingSupportCompanies.vue?vue&type=template&id=67bcfb90&scoped=true"
import script from "./ReceivingSupportCompanies.vue?vue&type=script&lang=js"
export * from "./ReceivingSupportCompanies.vue?vue&type=script&lang=js"

import "./ReceivingSupportCompanies.vue?vue&type=style&index=0&id=67bcfb90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bcfb90"]])

export default __exports__